<style>
  .alert{
  transition-duration:1s; /* <= creates fade out effect */
  transition-delay:1s;
}
</style>

<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ...
        </div>
        
        <div v-if="loading == false">
            <h2 class="title">Silicon Stripes Processing</h2>
            <form @submit.prevent="processBundle()" >
                <input class="input is-large" type="text" placeholder="Enter bundle code here" v-model="bundle_code" ref="focusme"><br /><br />
                <button class="button is-large is-fullwidth is-info" :disabled="loading==true" >Process</button>
                
            </form>

            <br /><br />

            <h2 class="title">Recent Actions Log</h2>
            <span v-for="(row, index) in actions_log" :key="index" :class="{'has-text-danger':row.error === true}">{{ row.label}}<br /></span>
            
        </div>
        
    </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'SiliconStripes',
  mixins: [OrderMixin],
  data() {
    
    return {
      order: {orderID: 0},
      area: 'silicon_stripes',
      loading: false,
      bundle_code: '',
      access_token: '',
      processed:false,
      actions_log : []
      
    }
  },
   methods: {
    
      async processBundle()
      {
          this.working = true

         
            
            var formdata = { 
                bundle_code: this.bundle_code,
                area : this.area
            }; 

            OrderService.bundleInputData(this.accessToken, formdata, this.area)
            .then(() => {
                //this.getOrder()
                //console.log(response)
                
                this.actions_log.unshift({label : "Bundle " + this.bundle_code + " processed successfully", error: false})

                this.bundle_code = ''
                this.$refs.focusme.focus()

                this.working = false
            }).catch((error) => {
              if(error.response.status == 409)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " has already been processed", error : true})
              }
              else if(error.response.status == 400)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " is not a valid barcode format", error : true})
              }
              else {
                alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
              }
              this.bundle_code = ''
                this.$refs.focusme.focus()
                
                this.working = false
            });
            
            
           
            
           
      },
     
   },
   mounted() {
    this.$nextTick(() => this.$refs.focusme.focus())
  },
  computed : {
      
  },
  watch: {

    
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
          
        });

        
  },
}
</script>